"use strict";
exports.__esModule = true;
exports.LocationTypeEnum = void 0;
exports.LocationTypeEnum = Object.freeze({
    REMOTE: "Remote",
    IN_PERSON: "In Person"
});
//# sourceMappingURL=location-type-enum.js.map